import React, { useEffect } from 'react';
import {connect} from "react-redux";

import { dimensionsUpdate } from '../../reducers/dimensions/actions';
import { documentManagementTableColsUpdate } from '../../reducers/document_management/actions';

const WindowDimensions = (props) => {

  useEffect(() => {
    function handleResize() {
      const { innerWidth: width, innerHeight: height } = window;

      props.dimensionsUpdate({ width, height });
    }

    function handleEventResize() {
      handleResize();
      // props.documentManagementTableColsUpdate({});
    }

    handleResize();

    window.addEventListener('resize', handleEventResize);
    return () => window.removeEventListener('resize', handleEventResize);
  }, []);

  return <div/>;
};

const mapStateToProps = state => ({});

const mapDispatchToProps = {
  documentManagementTableColsUpdate,
  dimensionsUpdate,
};


export default connect(mapStateToProps, mapDispatchToProps)(WindowDimensions);



// WEBPACK FOOTER //
// ./src/components/WindowDimensions/WindowDimensions.js